import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=5a304559&lang=scss"

const __exports__ = script;

export default __exports__